import React from 'react'
import { WithSearchList } from '$common/with-search-list'
import {
  VirtualizedInfiniteList,
  virtualizedListDefaultProps,
} from '$common/virtualized-list'
import { SearchableInfiniteListProps } from './searchable-list.types'

export function SearchableInfiniteList<Item, SearchParams>({
  items,
  itemSize,
  loadMore,
  hasMoreItemToLoad,
  searchQuery,
  searchHook,
  searchHookParams,
  loading,
  ...commonProps
}: SearchableInfiniteListProps<Item, SearchParams>) {
  return (
    <WithSearchList
      {...commonProps}
      hasSearchQuery={!!searchQuery}
      searchHook={searchHook}
      searchHookParams={searchHookParams}
    >
      <VirtualizedInfiniteList
        {...commonProps}
        items={items}
        itemSize={itemSize}
        loading={loading}
        loadMore={loadMore}
        hasMoreItemToLoad={hasMoreItemToLoad}
      />
    </WithSearchList>
  )
}

SearchableInfiniteList.defaultProps = virtualizedListDefaultProps
